import { combineReducers } from 'redux';
import auth from './auth';
import system from './system';

const rootReducer = combineReducers({
    auth,
    system,
});

export default rootReducer;
